import { columnSettings, tableWidth } from "./report-template-setting";

const settings = {};
for (let columnSetting of columnSettings) {
  settings[columnSetting.field] = columnSetting;
}

const ReportTemplateGroupFooter = (props) => {
  const { mykey, id, jenis_mobil, merek, nomor_polisi, tahun } =
    props.group_data;
  const group_count = props.group_count ?? 0;

  return <></>;
};

export default ReportTemplateGroupFooter;
